export default {
  back: false,
  loader: true,
  navigationMenu: true,
  pageLoader: false
}



// WEBPACK FOOTER //
// ./src/store/navigation/state.js